<template>
  <router-view />
</template>

<script>

export default {
  name: 'AdminView',
}
</script>
